// Copyright (c) 2018 Deere & Company

// import UpdateUnitMeasurements, {getDefaultState} from '../state/update-unit-measurements';

import MeasurementReading, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';

import actions from '../actions-list';

const resetMeasurements = state =>
    MeasurementReading.update(state, {
        $set: getDefaultState()
    });

const updateUnitMeasurements = (state, action) =>
    MeasurementReading.update(state, {
        [action.field]: {
            $set: action.data
        }
    });

const addFileForAmountOfUse = (state, action) =>
    MeasurementReading.update(state, {
        file: {
            $push: [action.data]
        }
    });

const updateFileAmountOfUse = (state, action) =>
    MeasurementReading.update(state, {
        file: {
            $set: action.files
        }
    });

const updateAddAmountOfUseUnitAmount = (state, action) =>
    MeasurementReading.update(state, {
        useAmount: {
            [action.property]: {
                $set: action.value
            }
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_LATEST_PER_EDITED_UNIT_MEASUREMENTS]: resetMeasurements,
        [actions.UPDATE_LATEST_EDITED_PER_UNIT_MEASUREMENTS]: updateUnitMeasurements,
        [actions.UPDATE_LATEST_EDITED_ADD_FILE_PER_UNIT_MEASUREMENTS]: addFileForAmountOfUse,
        [actions.UPDATE_LATEST_EDITED_DELETE_FILE_PER_UNIT_MEASUREMENTS]: updateFileAmountOfUse,
        [actions.UPDATE_ADD_AMOUNT_OF_USE_AMOUNT]: updateAddAmountOfUseUnitAmount
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/shared/reducers/update-unit-measurements.js